import TestimonialCard from './TestimonialCard';

export default TestimonialCard;
